module.exports = __webpack_public_path__ + "img/newlogo.2e9e51e0.png";